import * as React from 'react';
import { BaseComponent } from '../../BaseComponent';
import { LayoutType } from '../../../constants/LayoutConstants';
import { ViewSettingsStore } from '../../../stores/ViewSettingsStore';
import { AppConfigurationStore } from '../../../stores/AppConfigurationStore';
import { UIHelper } from '../../../utils/UIHelper';

interface CatalogLetterBarState {
    locked: boolean;
}

interface CatalogLetterBarProps {
    layoutType: LayoutType;
    scrollCallback: (scrollTop: number) => void;
    inSide: boolean;
}

export class CatalogLetterBar extends BaseComponent<CatalogLetterBarProps, CatalogLetterBarState> {
    private static LETTERS: Array<string> = [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H',
        'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
        'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X',
        'Y', 'Z',
        '#', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    ];

    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        return (
            <div className={'letter-bar' + (this.props.inSide ? ' letter-bar-inside' : '')}>
                <div className="letter-buttons">
                    {this.state.locked ? <div className="locked-letter-buttons"/> : null}
                    {CatalogLetterBar.LETTERS.map((letter: string, index: number) => {
                        if (index > 26) {
                            return null;
                        }

                        return (
                            // Children of letter-button must have css-property pointer-events: none
                            <div
                                key={index}
                                className="letter-button"
                                onClick={(event: React.MouseEvent) => { UIHelper.stopEvent(event); this.scrollTo(index); }}
                                onTouchStart={(event: React.TouchEvent) => { UIHelper.stopEvent(event); this.scrollTo(index); }}
                                onMouseMove={(event: React.MouseEvent) => {
                                    UIHelper.stopEvent(event);
                                    if (event.buttons != null && event.buttons === 1) {
                                        this.scrollTo(index);
                                    }
                                }}
                                onTouchMove={(event: React.TouchEvent) => {
                                    UIHelper.stopEvent(event);
                                    const myTouch: React.Touch = event.changedTouches[0];
                                    if (myTouch != null && myTouch.clientX != null && myTouch.clientY != null) {
                                        const element: HTMLElement = document.elementFromPoint(myTouch.clientX, myTouch.clientY) as HTMLElement;
                                        if (element && element.click && element.className === 'letter-button') {
                                            element.click();
                                        }
                                    }
                                }}
                            >
                                <div>{letter}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    protected onChange = (): void => {
        this.setState({
            locked: ViewSettingsStore.getState().sidebarlocked
        });
    };

    protected scrollTo(letterIndex: number): void {
        let scrolled: boolean = false;
        let heightFix: number = 10;
        if (!AppConfigurationStore.getState().iDevice) {
            switch (this.props.layoutType) {
                case LayoutType.DESKTOP:
                    heightFix = 106;
                    break;
                case LayoutType.TABLET:
                    heightFix = 84;
                    break;
                case LayoutType.SMALL:
                    heightFix = 103;
                    break;
                default:
                    break;
            }
        }
        CatalogLetterBar.LETTERS.map((letter: string, index: number) => {
            if (
                !scrolled &&
                index >= letterIndex &&
                letter !== '#' &&
                jQuery('#' + letter.toLocaleLowerCase() + '-catalogitem')[0] != null
            ) {
                if (false) {
                    jQuery('#' + letter.toLocaleLowerCase() + '-catalogitem')[0].scrollIntoView({behavior: 'smooth', block: 'start'});
                } else {
                    this.props.scrollCallback(jQuery('#' + letter.toLocaleLowerCase() + '-catalogitem')[0].offsetTop - heightFix);
                }
                scrolled = true;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/catalog/CatalogLetterBar.tsx